export default "__VITE_ASSET__956ff08b__"